module.exports = __webpack_public_path__ + "img/farmacogenetica-tarxeta.b8c8d62d.png";